import { render, staticRenderFns } from "./schoolRequestList.vue?vue&type=template&id=50b281d4&scoped=true"
import script from "./schoolRequestList.vue?vue&type=script&lang=js"
export * from "./schoolRequestList.vue?vue&type=script&lang=js"
import style0 from "./schoolRequestList.vue?vue&type=style&index=0&id=50b281d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b281d4",
  null
  
)

export default component.exports